import { BlocksIconTagFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/tag-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTagFilled = createComponent({
  react: React,
  tagName: 'cat-icon-tag-filled',
  elementClass: BlocksIconTagFilled
});
